import React from 'react'
import { useDispatch } from 'react-redux'
import { FiSave } from 'react-icons/fi'

import ControlButton from '../../../Buttons/ControlButton'

import { setDownloadPointsBoxOpen } from '../../../../redux/actions/points.actions'

export default function DownloadPoints() {
  const dispatch = useDispatch()

  const onOpenDownloadDialog = () => {
    dispatch(setDownloadPointsBoxOpen())
  }

  return (
    <ControlButton
      icon={FiSave}
      ariaLabel="Download points"
      onClick={onOpenDownloadDialog}
      customClass="ol-download-icon"
    ></ControlButton>
  )
}
